import {
	downloadDataBoxAttachmentQuery,
	useAxiosInstance,
	useDownloadPoMutation,
} from '@gov-nx/api';
import type { OnAttachmentSaveParams } from '@gov-nx/component/common';

export interface AttachmentDownloadProps {
	onError: (attachmentHash: string, error: Error) => void;
	onSuccess: (data: OnAttachmentSaveParams) => void;
}

export const useAttachmentDownload = (props: AttachmentDownloadProps) => {
	const { axiosInstance } = useAxiosInstance();

	return useDownloadPoMutation(downloadDataBoxAttachmentQuery(axiosInstance), {
		onError: (error, attachmentData) =>
			props.onError(attachmentData.attachment.hashPrilohy as string, error),
		onSuccess: (data) =>
			props.onSuccess({
				antivirus: data.antivirus,
				fileName: data.fileName,
				blob: data.blob,
				id: data.variables.attachment.hashPrilohy as string,
			}),
	});
};
